import LocationIcon from "../icons/LocationIcon";
import type { ISvgIconLink } from "./SvgIconLink";
import { SvgAppearance, SvgIconLink } from "./SvgIconLink";

import * as css from "./MapLink.module.css";

export class MapLink extends SvgIconLink {
    protected get svgIcon() {
        return (
            <span className={css.icon}>
                <LocationIcon />
            </span>
        );
    }

    public static defaultProps: ISvgIconLink = {
        ...SvgIconLink.defaultProps,
        svgAppearance: SvgAppearance.White,
    };

    public cssClassName: string = css.mapLinkComponent;
}
